import {
  I2cRadioButton,
  I2cRadioGroup,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { masterCardBillingUpdater, visaBillingUpdater } from "./stringUtils";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchemaAutomaticAccountUpdater } from "./validationSchema";

const AccountUpdateService = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaAutomaticAccountUpdater),
    mode: "all",
    reValidateMode: "all",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      cn_automatic_account_updater_service_mastercard_automatic_billing_updater: "no", // Default to "No"
      cn_automatic_account_updater_service_visa_account_updater: "no", // Default to "No"
    },
  });

  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "cn_automatic_account_updater_service_mastercard_automatic_billing_updater",
    "cn_automatic_account_updater_service_visa_account_updater"
  ];

  // Handle value changes and update parent state
  const handleValueChanges = React.useCallback(() => {
    const values = methods.getValues();
    setAddFormData((prev) => ({
      ...prev,
      2: {
        ...prev[2],
        "2_4": { ...values },
      },
    }));
  }, [methods, setAddFormData]);

  // Load existing form data
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        const value = formDataJson[2]?.["2_4"]?.[field];
        if (value !== undefined && value !== null) {
          methods.setValue(field, value);
        }
      });
      methods.trigger();
      handleValueChanges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching]);

  // Trigger validation when component mounts
  useEffect(() => {
    methods.trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update form validation state when errors change
  useEffect(() => {
    const errorsLength = Object.keys(errors)?.length;
    if (errorsLength === 0) {
      setFormValidStates("2_4", true);
    } else {
      setFormValidStates("2_4", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  // Handle radio button change
  const handleRadioChange = (fieldName, value) => {
    methods.setValue(fieldName, value);
    methods.trigger();
    handleValueChanges();
  };

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md">
          <div i2c-grid="12">
            <div className="mb-16">
              <Controller
                name="cn_automatic_account_updater_service_mastercard_automatic_billing_updater"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cRadioGroup
                      {...field}
                      label="Would you like to enable MasterCard Automatic Billing Updater (ABU) service for your cardholders?"
                      value={field.value}
                      onI2cChange={(e) => handleRadioChange("cn_automatic_account_updater_service_mastercard_automatic_billing_updater", e.target.value)}
                    >
                      {masterCardBillingUpdater.map((option) => (
                        <I2cRadioButton key={option.value} value={option.value}>
                          {option.label}
                        </I2cRadioButton>
                      ))}
                    </I2cRadioGroup>
                    {errors.cn_automatic_account_updater_service_mastercard_automatic_billing_updater && (
                      <ErrorMessage message={errors.cn_automatic_account_updater_service_mastercard_automatic_billing_updater.message} />
                    )}
                  </>
                )}
              />
            </div>
            <div>
              <Controller
                name="cn_automatic_account_updater_service_visa_account_updater"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cRadioGroup
                      {...field}
                      label="Would you like to enable Visa Account Updater (VAU) service for your cardholders?"
                      value={field.value}
                      onI2cChange={(e) => handleRadioChange("cn_automatic_account_updater_service_visa_account_updater", e.target.value)}
                    >
                      {visaBillingUpdater.map((option) => (
                        <I2cRadioButton key={option.value} value={option.value}>
                          {option.label}
                        </I2cRadioButton>
                      ))}
                    </I2cRadioGroup>
                    {errors.cn_automatic_account_updater_service_visa_account_updater && (
                      <ErrorMessage message={errors.cn_automatic_account_updater_service_visa_account_updater.message} />
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AccountUpdateService;
